import { BaseChatPackage } from '../utils'
import { ChatsServices } from './chats'
import { MessagesServices } from './messages'
import { GroupsServices } from './groups'
import { ExcludedWordsService } from './excludedWords'

export interface ChatServices extends ChatsServices, MessagesServices, GroupsServices, ExcludedWordsService {}

export class ChatServices extends BaseChatPackage {
  constructor(...args: ConstructorParameters<typeof BaseChatPackage>) {
    super(...args)
    const chatsService = new ChatsServices(...args)
    const messagesService = new MessagesServices(...args)
    const groupsService = new GroupsServices(...args)
    const excludedWordsService = new ExcludedWordsService(...args)
    this.bindMethods(chatsService)
    this.bindMethods(messagesService)
    this.bindMethods(groupsService)
    this.bindMethods(excludedWordsService)
  }
}
